import { render, staticRenderFns } from "./SubMenuItemBulk.vue?vue&type=template&id=75a70edc&scoped=true&"
import script from "./SubMenuItemBulk.vue?vue&type=script&lang=js&"
export * from "./SubMenuItemBulk.vue?vue&type=script&lang=js&"
import style0 from "./SubMenuItemBulk.vue?vue&type=style&index=0&id=75a70edc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a70edc",
  null
  
)

component.options.__file = "SubMenuItemBulk.vue"
export default component.exports